// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ValidationMethods-module-verificationImage-9mDJD{display:block;height:auto;margin-top:24px;margin-bottom:20px;width:100%}.ValidationMethods-module-formContainer--FPh8{margin-bottom:40px}.ValidationMethods-module-methodsRow-imk-e{display:flex;flex-wrap:wrap}.ValidationMethods-module-identificationLabelContainer-Z9uVH{margin-top:20px;margin-bottom:10px}.ValidationMethods-module-actionContainer-Q6Dde{display:flex;justify-content:center;margin-top:30px}.ValidationMethods-module-methodsTitle-UheD4{color:#5c615e}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"verificationImage": "ValidationMethods-module-verificationImage-9mDJD",
	"formContainer": "ValidationMethods-module-formContainer--FPh8",
	"methodsRow": "ValidationMethods-module-methodsRow-imk-e",
	"identificationLabelContainer": "ValidationMethods-module-identificationLabelContainer-Z9uVH",
	"actionContainer": "ValidationMethods-module-actionContainer-Q6Dde",
	"methodsTitle": "ValidationMethods-module-methodsTitle-UheD4"
};
export default ___CSS_LOADER_EXPORT___;
